export default [
    'red-1-0',
    'red-2-0',
    'red-3-0',
    'red-4-0',
    'red-1-1',
    'red-2-1',
    'red-3-1',
    'red-4-1',
    'gray-1-0',
    'gray-1-1',
    'green-1-0',
    'primary',
    'accent'
];
